/* global Highcharts */

(function () {
  'use strict';

  var id = 'cues';

  // Add onto the wsLrs.cards module...
  angular.module('wsLrs.cards').
  // All injectable services need to be named with a prefix (id) to "namespace" them since we are operating
  // within one global wsLrs module that's shared by all CardTemplates.
  factory(id + ".Utils", ['$q', '$timeout', 'Api', 'CardQueryResource', '$http', 'wsColors', function ($q, $timeout, Api, CardQueryResource, $http, wsColors) {
    return {
      fetchDataFromResource: function fetchDataFromResource(resources, includedGroups, roleId, segmentId, permissionId) {
        var groups = [];
        if (includedGroups) {
          groups = _.map(includedGroups, function (group) {
            return group.id;
          });
        }

        // Append the special groups to AND with the main set of groups
        if (typeof roleId !== 'undefined' && roleId !== null && roleId !== 0) {
          groups.push("AND_" + roleId);
        }
        if (typeof segmentId !== 'undefined' && segmentId !== null && segmentId !== 0) {
          groups.push("AND_" + segmentId);
        }
        if (typeof permissionId !== 'undefined' && permissionId !== null && permissionId !== 0) {
          groups.push("AND_" + permissionId);
        }
        var queryResources = _.map(resources, function (resource) {
          return '/cues/' + resource;
        });
        var future = $q.defer();
        $timeout(function () {
          var params = {};
          if (groups.length > 0) {
            params.groups = groups.join();
          }
          future.resolve(CardQueryResource.getWithProgress({
            path: queryResources,
            params: params,
            progressChannel: 'genericActivity'
          }));
        }.bind(this));
        return future.promise;
      },
      addSpecialGroupRolesToScope: function addSpecialGroupRolesToScope($scope) {
        // Set up the special group dropdowns
        $scope.selectedRoleId = 0;
        $scope.roles = [{
          id: 0,
          name: "All Roles"
        }];
        $http.get(Api.url("/groups?type.name=Role", false, true)).then(function success(response) {
          $scope.roles = $scope.roles.concat(response.data.results);
        });
        $scope.selectedGroupSegmentId = 0;
        $scope.segments = [{
          id: 0,
          name: "All Segments"
        }];
        $http.get(Api.url("/groups?type.name=Segment", false, true)).then(function success(response) {
          $scope.segments = $scope.segments.concat(response.data.results);
        });
        $scope.selectedPermissionId = 0;
        $scope.permissions = [{
          id: 0,
          name: "All Permissions"
        }];
        $http.get(Api.url("/groups?type.name=Permission", false, true)).then(function success(response) {
          $scope.permissions = $scope.permissions.concat(response.data.results);
        });
      },
      getListerData: function getListerData(data, getMatchLabel) {
        var items = _.map(_.keys(data), function (id) {
          return {
            id: id,
            name: data[id].name,
            count: data[id].measures[0].value,
            timeline: {
              type: "interaction-timeline",
              data: [],
              lastDate: new Date(),
              firstDate: new Date(),
              getMatchLabel: getMatchLabel
            },
            thisWeekCount: 0,
            prevWeekCount: 0
          };
        });

        // Create ranks, same counts should have same rank
        items = _.sortBy(items, 'count');
        items.reverse();
        var rank = 0;
        var prevCount = -1;
        _.forEach(items, function (item) {
          if (prevCount !== item.count) {
            rank++;
          }
          item.rank = rank;
          prevCount = item.count;
        });
        var oneWeekAgo = new Date();
        oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
        oneWeekAgo = oneWeekAgo.toISOString().substring(0, 10);
        var twoWeeksAgo = new Date();
        twoWeeksAgo.setDate(twoWeeksAgo.getDate() - 14);
        twoWeeksAgo = twoWeeksAgo.toISOString().substring(0, 10);
        _.forEach(items, function (item) {
          var timestamps = data[item.id].measures[1].value;
          _.forEach(timestamps, function (timestamp) {
            if (timestamp.value) {
              var day = timestamp.value.substring(0, 10);
              if (day > oneWeekAgo) {
                item.thisWeekCount++;
              } else if (day > twoWeeksAgo) {
                item.prevWeekCount++;
              }
              var timeLineItem = _.findWhere(item.timeline.data, {
                date: day
              });
              if (timeLineItem === undefined) {
                item.timeline.data.push({
                  date: day,
                  emphasis: false,
                  total: 1,
                  exactMatches: 1
                });
              } else {
                timeLineItem.total++;
                timeLineItem.exactMatches++;
              }
            }
          });
        });

        // Init the first date of data for this person for the timeline
        _.forEach(items, function (item) {
          item.timeline.firstDate = new Date(_.min(item.timeline.data, function (t) {
            return new Date(t.date);
          }).date);

          // And add any other measures
          if (data[item.id].measures.length > 2) {
            for (var i = 2; i < data[item.id].measures.length; i++) {
              item[data[item.id].measures[i].name] = data[item.id].measures[i].value;
            }
          }
          item.change = item.thisWeekCount - item.prevWeekCount;
        });

        // Find the absolute earliest date and assign it to all timelines so everybody has the same scale
        var startDate = _.min(_.map(items, function (item) {
          return item.timeline.firstDate;
        }));
        _.forEach(items, function (item) {
          item.timeline.firstDate = startDate;
        });
        return items;
      },
      getChartData: function getChartData(data) {
        var aggregations = {};

        // We will aggregate into months
        _.forEach(_.keys(data), function (id) {
          var timestamps = data[id].measures[1].value;
          _.forEach(timestamps, function (timestamp) {
            if (timestamp.value) {
              var month = timestamp.value.substring(0, 7);
              if (!_.has(aggregations, month)) {
                aggregations[month] = {
                  statementCounts: 0,
                  uniqueIds: []
                };
              }
              aggregations[month].statementCounts++;
              if (!_.contains(aggregations[month].uniqueIds, id)) {
                aggregations[month].uniqueIds.push(id);
              }
            }
          });
        });
        return aggregations;
      },
      sortItems: function sortItems(items, params) {
        var limit = params._limit || params.limit || 10,
          offset = params._offset || 0;

        /*jshint camelcase: false */
        if (params.order_by) {
          var reverse = false;
          var orderBy = params.order_by;
          if (orderBy.lastIndexOf("-", 0) === 0) {
            orderBy = orderBy.substring(1, orderBy.length);
            reverse = true;
          }
          var orderingMethod = null;
          if (orderBy === "name") {
            orderingMethod = function orderingMethod(item) {
              return item.name.toLowerCase();
            };
          } else {
            orderingMethod = function orderingMethod(item) {
              return item[orderBy];
            };
          }
          items = _.sortBy(items, orderingMethod);
          if (reverse) {
            items.reverse();
          }
          var numResults = _.size(items);
          items = items.slice(offset, limit + offset);
          return {
            "results": items,
            "count": numResults
          };
        }
        /*jshint camelcase: true */
      },
      monthDiff: function monthDiff(d1, d2) {
        var months;
        months = (d2.getFullYear() - d1.getFullYear()) * 12;
        months -= d1.getMonth() + 1;
        months += d2.getMonth();
        return months <= 0 ? 0 : months;
      },
      getChartDef: function getChartDef($scope, chartData, learnerChartData) {
        $scope.distinctCount = 0;
        $scope.distinctLearnerIds = [];
        var mainSeries = [];
        var uniqueLearnerSeries = [];
        if (learnerChartData) {
          $scope.distinctIds = [];
          _.forEach(_.keys(chartData), function (dateString) {
            var dt = moment.utc(dateString + "-01");
            mainSeries.push([dt.toDate().getTime(), chartData[dateString].uniqueIds.length]);
            $scope.distinctIds = _.union($scope.distinctIds, chartData[dateString].uniqueIds);
          });
          _.forEach(_.keys(chartData), function (dateString) {
            var dt = moment.utc(dateString + "-01");
            uniqueLearnerSeries.push([dt.toDate().getTime(), learnerChartData[dateString].uniqueIds.length]);
            $scope.distinctLearnerIds = _.union($scope.distinctLearnerIds, learnerChartData[dateString].uniqueIds);
          });
        } else {
          _.forEach(_.keys(chartData), function (dateString) {
            var dt = moment.utc(dateString + "-01");
            mainSeries.push([dt.toDate().getTime(), chartData[dateString].statementCounts]);
            $scope.distinctCount += chartData[dateString].statementCounts;
          });
          _.forEach(_.keys(chartData), function (dateString) {
            var dt = moment.utc(dateString + "-01");
            uniqueLearnerSeries.push([dt.toDate().getTime(), chartData[dateString].uniqueIds.length]);
            $scope.distinctLearnerIds = _.union($scope.distinctLearnerIds, chartData[dateString].uniqueIds);
          });
        }
        if ($scope.distinctIds) {
          $scope.distinctCount = $scope.distinctIds.length;
        }

        // Sort by timestamp
        mainSeries = _.sortBy(mainSeries, function (pair) {
          return pair[0];
        });
        uniqueLearnerSeries = _.sortBy(uniqueLearnerSeries, function (pair) {
          return pair[0];
        });

        // Plotband dates -- Going 39 days back looks to be good when the interval is a month
        var currentMonth = new Date();
        currentMonth.setDate(currentMonth.getMonth(), 1);
        var startPlotLine = new Date(currentMonth.getTime());
        startPlotLine.setDate(startPlotLine.getDate() - 18);
        var endPlotLine = new Date(currentMonth.getTime());
        endPlotLine.setDate(endPlotLine.getDate() + 15);
        return {
          title: {
            text: ''
          },
          subtitle: {
            text: ''
          },
          tooltip: {
            formatter: function formatter() {
              var s = '<b>' + Highcharts.dateFormat('%B %Y', new Date(this.x)) + '</b>';
              $.each(this.points, function () {
                s += '<br/>&bull; ' + this.series.name + ': ' + this.y;
              });
              return s;
            },
            shared: true
          },
          xAxis: {
            type: 'datetime',
            title: {
              text: ''
            },
            "labels": {
              "format": "{value:%b %Y}"
            },
            plotBands: [{
              color: wsColors.wsWhite,
              from: startPlotLine,
              to: endPlotLine
            }]
          },
          yAxis: [{
            allowDecimals: false,
            title: {
              text: $scope.mainSeriesTitle
            },
            min: 0
          }, {
            title: {
              text: 'Learners'
            },
            opposite: true,
            min: 0
          }],
          series: [{
            name: $scope.mainSeriesTitle,
            data: mainSeries,
            type: 'line',
            zIndex: 1,
            color: 'black'
          }, {
            name: 'Learners',
            data: uniqueLearnerSeries,
            type: 'column',
            yAxis: 1
          }]
        };
      }
    };
  }]).config(['$routeProvider', function ($routeProvider) {
    // Add routes
    $routeProvider.when('/' + id + '/most-active-learners/:cardId', {
      templateUrl: 'modules/app/cues/genericActivityOverTimeDetail.html',
      controller: id + ".mostActiveLearners.Detail",
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    }).when('/' + id + '/popular-content-items/:cardId', {
      templateUrl: 'modules/app/cues/genericActivityOverTimeDetail.html',
      controller: id + ".popularContentItems.Detail",
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    }).when('/' + id + '/popular-content-types/:cardId', {
      templateUrl: 'modules/app/cues/genericActivityOverTimeDetail.html',
      controller: id + ".popularContentTypes.Detail",
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    }).when('/' + id + '/competencies/:cardId', {
      templateUrl: 'modules/app/cues/competenciesDetail.html',
      controller: id + ".competencies.Detail",
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    }).when('/' + id + '/common-learning-paths/:cardId', {
      templateUrl: 'modules/app/cues/commonLearningPathsDetail.html',
      controller: id + ".commonLearningPaths.Detail",
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    });
  }]).controller(id + ".mostActive.Card", ["$scope", "CardRegistry", id + ".Utils", function ($scope, CardRegistry, Utils) {
    $scope.config = CardRegistry.get($scope.cardId).configuration;
    Utils.fetchDataFromResource($scope.reportResource).then(function (data) {
      var unprocessedData = data.results[0].result.data;
      $scope.items = Utils.getListerData(unprocessedData);
      $scope.hasData = $scope.items.length > 0;
    });
  }]).controller(id + ".mostActiveLearners.Card", ["$scope", "$controller", function ($scope, $controller) {
    $scope.reportResource = ['most-active-learners'];
    $scope.hasData = null;
    $controller(id + ".mostActive.Card", {
      $scope: $scope
    });
  }]).controller(id + ".popularContentItems.Card", ["$scope", "$controller", function ($scope, $controller) {
    $scope.reportResource = ['popular-content'];
    $controller(id + ".mostActive.Card", {
      $scope: $scope
    });
  }]).controller(id + ".popularContentTypes.Card", ["$scope", "$controller", function ($scope, $controller) {
    $scope.reportResource = ['popular-activity-types'];
    $controller(id + ".mostActive.Card", {
      $scope: $scope
    });
  }]).controller(id + ".commonLearningPaths.Card", ["$scope", "CardRegistry", "CardQueryResource", function ($scope, CardRegistry, CardQueryResource) {
    $scope.config = CardRegistry.get($scope.cardId).configuration;
    CardQueryResource.getWithProgress({
      path: "/cues/learning-paths-status",
      progressChannel: "learningPathStatus"
    }).then(function (response) {
      if (response.results.length > 0) {
        $scope.hasData = true;
        $scope.items = [];
        _.each(response.results, function (result) {
          $scope.items.push({
            name: result.name,
            totalRegistrations: result.result.registeredCount,
            inProgressCount: result.result.registeredCount - (result.result.progressData['0'] + result.result.progressData['100'])
          });
        });
      }
    });
  }]).controller(id + ".competencies.Card", ["$scope", "CardRegistry", "CardQueryResource", function ($scope, CardRegistry, CardQueryResource) {
    $scope.config = CardRegistry.get($scope.cardId).configuration;
    CardQueryResource.getWithProgress({
      path: "/cues/competencies-status",
      progressChannel: "competenciesStatus"
    }).then(function (response) {
      if (response.results.length > 0) {
        $scope.hasData = true;
        $scope.items = [];
        _.each(response.results, function (result) {
          $scope.items.push({
            name: result.name,
            totalRegistrations: result.result.registeredCount,
            completedCount: result.result.progressData['100']
          });
        });
      } else {
        $scope.hasData = false;
      }
    });
  }]).controller(id + ".learningPathsNotTraveled.Card", ["$scope", "CardRegistry", "CardQueryResource", function ($scope, CardRegistry, CardQueryResource) {
    $scope.config = CardRegistry.get($scope.cardId).configuration;
    CardQueryResource.get("/cues/learning-paths-not-traveled", $scope.cardId).then(function (response) {
      var allLearningPaths = response.data;
      $scope.items = _.filter(allLearningPaths, function (status) {
        return status.notStartedCount === status.totalRegistrations;
      });
      if ($scope.items.length > 0) {
        $scope.percentNotStarted = $scope.items.length / allLearningPaths.length * 100;
      } else {
        $scope.percentNotStarted = 0;
      }
      $scope.hasData = allLearningPaths.length > 0;
    });
  }]).controller(id + ".mostActive.Detail", ["$scope", "$routeParams", "CardRegistry", "CardUtils", id + ".Utils", "$controller", "$q", function ($scope, $routeParams, CardRegistry, CardUtils, Utils, $controller, $q) {
    $scope.cardId = $routeParams.cardId;
    CardUtils.setNavElements($scope, $routeParams.cardId);
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
    Utils.addSpecialGroupRolesToScope($scope);
    $scope.fetchData = function fetchData(params) {
      /*jshint camelcase: false */
      if ($scope.fetchInProgress) {
        return $scope.dataFetched;
      } else if ($scope.items) {
        var sortedList = Utils.sortItems($scope.items, params);
        var deferred = $q.defer();
        deferred.resolve(sortedList);
        $scope.hasData = $scope.items.length > 0;
        return deferred.promise;
      } else {
        $scope.fetchInProgress = true;
        return Utils.fetchDataFromResource($scope.reportResource, $scope.includedGroups, $scope.selectedRoleId, $scope.selectedGroupSegmentId, $scope.selectedPermissionId).then(function (data) {
          var unprocessedData;
          if (_.isArray(data)) {
            // See wsDetailPagenote directive for details
            var reportMd = data[0];
            reportMd.processedHits += data[1].processedHits;
            $scope.pagenote.setReportMetadata(reportMd);
            unprocessedData = data[0].results[0].result.data;
            var unprocessedLearnerData = data[1].results[0].result.data;
            // For the chart
            $scope.chart = Utils.getChartDef($scope, Utils.getChartData(unprocessedData), Utils.getChartData(unprocessedLearnerData));
          } else {
            // See wsDetailPagenote directive for details
            $scope.pagenote.setReportMetadata(data);
            unprocessedData = data.results[0].result.data;
            $scope.chart = Utils.getChartDef($scope, Utils.getChartData(unprocessedData));
          }
          var getMatchLabel;
          if ($scope.entityType === 'Learner') {
            getMatchLabel = function getMatchLabel(match) {
              return match + (match === 1 ? ' learning activity' : ' learning activities');
            };
          } else {
            getMatchLabel = function getMatchLabel(match) {
              return match + (match === 1 ? ' view' : ' views');
            };
          }

          // For the lister
          $scope.items = Utils.getListerData(unprocessedData, getMatchLabel);
          var listerData = Utils.sortItems($scope.items, {
            order_by: 'count'
          });
          $scope.hasData = listerData.count > 0;

          // If there is an active filter it means we have no data due to filtering so hasData should be true
          if ($scope.hasData) {
            $scope.monthCount = Utils.monthDiff(new Date($scope.chart.series[0].data[0][0]), new Date());
          } else if ($scope.includedGroups.length > 0 || $scope.selectedRoleId > 0 || $scope.selectedGroupSegmentId > 0 || $scope.selectedPermissionId > 0) {
            $scope.monthCount = 0;
            $scope.hasData = true;
          }
          $scope.fetchInProgress = false;
          return listerData;
        });
      }
      /*jshint camelcase: true */
    };
    $scope.dataFetched = $scope.fetchData({});
    $scope.defaultSortBy = "rank";
    $scope.sortControls = [{
      "title": "Rank",
      "options": {
        "Ascending": "rank",
        "Descending": "-rank"
      }
    }, {
      "title": $scope.entityType,
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": $scope.listEntity,
      "options": {
        "Ascending": "count",
        "Descending": "-count"
      }
    }];
    // The learner view doesn't have a learner count, all other views do
    if ($scope.reportResource[0] !== 'most-active-learners') {
      $scope.sortControls.push({
        "title": "Learners",
        "options": {
          "Ascending": "uniquePeopleCount",
          "Descending": "-uniquePeopleCount"
        }
      });
    }
    $scope.sortControls.push({
      "title": "Timeline"
    });
    $scope.includedGroups = [];
    $scope.updateSelectedGroups = function updateSelectedGroups(newEntity, selectionList) {
      $scope.includedGroups = selectionList;
      $scope.refreshFilter();
    };
    $scope.refreshFilter = function refreshFilter() {
      delete $scope.items; // clear the cache to force a server-side call with new group info
      $scope.$$childTail.fetch();
    };
  }]).controller(id + ".mostActiveLearners.Detail", ["$scope", "$controller", function ($scope, $controller) {
    $scope.reportResource = ['most-active-learners'];
    $scope.entityType = 'Learner';
    $scope.reportEntity = 'Learning Activities';
    $scope.listEntity = 'Learning Activities';
    $scope.reportVerbClause = 'participated in a total of';
    $scope.activityType = 'Learner Activity';
    $scope.cardTitle = 'Most Active Learners';
    $scope.mainSeriesTitle = 'Learner Activities';
    $controller(id + ".mostActive.Detail", {
      $scope: $scope
    });
  }]).controller(id + ".popularContentItems.Detail", ["$scope", "$controller", function ($scope, $controller) {
    $scope.reportResource = ['popular-content', 'most-active-learners'];
    $scope.entityType = 'Content';
    $scope.listEntity = 'Views';
    $scope.reportEntity = 'Pieces of Content';
    $scope.reportVerbClause = 'viewed';
    $scope.activityType = 'Content';
    $scope.cardTitle = 'Popular Content Items';
    $scope.mainSeriesTitle = 'Content Items Viewed';
    $controller(id + ".mostActive.Detail", {
      $scope: $scope
    });
  }]).controller(id + ".popularContentTypes.Detail", ["$scope", "$controller", function ($scope, $controller) {
    $scope.reportResource = ['popular-activity-types', 'most-active-learners'];
    $scope.entityType = 'Content Type';
    $scope.reportEntity = 'Different Types of Content';
    $scope.listEntity = 'Views';
    $scope.reportVerbClause = 'engaged with';
    $scope.activityType = 'Content Type';
    $scope.cardTitle = 'Popular Content Types';
    $scope.mainSeriesTitle = 'Content Types';
    $controller(id + ".mostActive.Detail", {
      $scope: $scope
    });
  }]).controller(id + ".commonLearningPaths.Detail", ["$scope", "CardRegistry", "CardUtils", id + ".Utils", "$controller", "$q", "$routeParams", function ($scope, CardRegistry, CardUtils, Utils, $controller, $q, $routeParams) {
    $scope.cardTitle = 'Common Learning Paths';
    $scope.cardId = $routeParams.cardId;
    CardUtils.setNavElements($scope, $routeParams.cardId);
    Utils.addSpecialGroupRolesToScope($scope);
    $scope.fetchData = function fetchData(params) {
      if ($scope.items) {
        //var sortedList =  sortLearningPathInfo($scope.items, params);
        var limit = params._limit || params.limit || 10,
          offset = params._offset || 0;
        var deferred = $q.defer();

        /*jshint camelcase: false */
        if (params.order_by) {
          var reverse = false;
          var orderBy = params.order_by;
          if (orderBy.lastIndexOf("-", 0) === 0) {
            orderBy = orderBy.substring(1, orderBy.length);
            reverse = true;
          }
          var orderingMethod = null;
          if (orderBy === "name") {
            orderingMethod = function orderingMethod(item) {
              return item.name.toLowerCase();
            };
          } else {
            orderingMethod = function orderingMethod(item) {
              return item[orderBy].value;
            };
          }
          var sortedItems = _.sortBy($scope.items, orderingMethod);

          // Filter out results with NOBODY in progress
          sortedItems = _.filter(sortedItems, function (item) {
            return item.inProgressCount + item.completedCount > 0;
          });
          if (reverse) {
            sortedItems.reverse();
          }
          sortedItems = sortedItems.slice(offset, limit + offset);
          var numResults = _.size(sortedItems);
          deferred.resolve({
            "results": sortedItems,
            "count": numResults
          });
          $scope.hasData = sortedItems.length > 0;
          return deferred.promise;
        } else {
          deferred.resolve({
            "results": $scope.items,
            "count": $scope.items.length
          });
          $scope.hasData = $scope.items.length > 0;
          return deferred.promise;
        }
        /*jshint camelcase: true */
      } else {
        return Utils.fetchDataFromResource(["learning-paths-status"], $scope.includedGroups, $scope.selectedRoleId, $scope.selectedGroupSegmentId, $scope.selectedPermissionId).then(function (response) {
          // See wsDetailPagenote directive for details
          $scope.pagenote.setReportMetadata(response);
          $scope.items = [];
          _.each(response.results, function (result) {
            $scope.items.push({
              name: result.name,
              totalRegistrations: result.result.registeredCount,
              inProgressCount: result.result.registeredCount - (result.result.progressData['0'] + result.result.progressData['100']),
              completedCount: result.result.progressData['100']
            });
          });

          // For the lister
          var limit = params._limit || params.limit || 10,
            offset = params._offset || 0;

          // Filter out results with NOBODY in progress
          var vals = _.filter($scope.items, function (item) {
            return item.inProgressCount + item.completedCount > 0;
          });
          $scope.inProgressLearners = _.reduce(vals, function (memo, item) {
            return memo + item.inProgressCount;
          }, 0);
          $scope.numResults = _.size(vals);
          vals = vals.slice(offset, limit + offset);
          $scope.hasData = $scope.items.length > 0;
          return {
            "results": vals,
            "count": $scope.numResults
          };
        });
      }
    };
    $scope.defaultSortBy = "name";
    $scope.sortControls = [{
      "title": "Learning Path",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "Learners in Common",
      "options": {
        "Ascending": "inProgressCount",
        "Descending": "-inProgressCount"
      }
    }, {
      "title": "Learner Completions",
      "options": {
        "Ascending": "completedCount",
        "Descending": "-completedCount"
      }
    }];
    $scope.includedGroups = [];
    $scope.updateSelectedGroups = function updateSelectedGroups(newEntity, selectionList) {
      $scope.includedGroups = selectionList;
      $scope.refreshFilter();
    };
    $scope.refreshFilter = function refreshFilter() {
      delete $scope.items; // clear the cache to force a server-side call with new group info
      $scope.fetch();
    };
  }]).controller(id + ".competencies.Detail", ["$scope", "CardRegistry", "CardUtils", id + ".Utils", "$controller", "$q", "$routeParams", function ($scope, CardRegistry, CardUtils, Utils, $controller, $q, $routeParams) {
    $scope.cardTitle = 'Competencies';
    $scope.cardId = $routeParams.cardId;
    CardUtils.setNavElements($scope, $routeParams.cardId);
    Utils.addSpecialGroupRolesToScope($scope);
    $scope.fetchData = function fetchData(params) {
      if ($scope.items) {
        //var sortedList =  sortLearningPathInfo($scope.items, params);
        var limit = params._limit || params.limit || 10,
          offset = params._offset || 0;
        var deferred = $q.defer();

        /*jshint camelcase: false */
        if (params.order_by) {
          var reverse = false;
          var orderBy = params.order_by;
          if (orderBy.lastIndexOf("-", 0) === 0) {
            orderBy = orderBy.substring(1, orderBy.length);
            reverse = true;
          }
          var orderingMethod = null;
          if (orderBy === "name") {
            orderingMethod = function orderingMethod(item) {
              return item.name.toLowerCase();
            };
          } else {
            orderingMethod = function orderingMethod(item) {
              return item[orderBy].value;
            };
          }
          var sortedItems = _.sortBy($scope.items, orderingMethod);
          if (reverse) {
            sortedItems.reverse();
          }
          sortedItems = sortedItems.slice(offset, limit + offset);

          // Filter out results with NOBODY in progress
          sortedItems = _.filter(sortedItems, function (item) {
            return item.inProgressCount + item.completedCount > 0;
          });
          var numResults = _.size(sortedItems);
          deferred.resolve({
            "results": sortedItems,
            "count": numResults
          });
          $scope.hasData = sortedItems.length > 0;
          return deferred.promise;
        } else {
          deferred.resolve({
            "results": $scope.items,
            "count": $scope.items.length
          });
          $scope.hasData = $scope.items.length > 0;
          return deferred.promise;
        }
        /*jshint camelcase: true */
      } else {
        return Utils.fetchDataFromResource(["learning-paths-status"], $scope.includedGroups, $scope.selectedRoleId, $scope.selectedGroupSegmentId, $scope.selectedPermissionId).then(function (response) {
          // See wsDetailPagenote directive for details
          $scope.pagenote.setReportMetadata(response);
          $scope.items = [];
          _.each(response.results, function (result) {
            $scope.items.push({
              name: result.name,
              totalRegistrations: result.result.registeredCount,
              inProgressCount: result.result.registeredCount - (result.result.progressData['0'] + result.result.progressData['100']),
              completedCount: result.result.progressData['100'],
              learningPaths: result.result.childCriteriaCount,
              learningPathCriteria: result.result.subAccomplishmentCriteriaCount
            });
          });

          // For the lister
          var limit = params._limit || params.limit || 10,
            offset = params._offset || 0;

          // Filter out results with NOBODY in progress, really?  We still show completion!
          var vals = _.filter($scope.items, function (item) {
            return item.inProgressCount + item.completedCount > 0;
          });
          $scope.inProgressLearners = _.reduce(vals, function (memo, item) {
            return memo + item.inProgressCount;
          }, 0);
          $scope.numResults = _.size(vals);
          var numResults = _.size(vals);
          vals = vals.slice(offset, limit + offset);
          $scope.hasData = $scope.items.length > 0;
          return {
            "results": vals,
            "count": numResults
          };
        });
      }
    };
    $scope.defaultSortBy = "name";
    $scope.sortControls = [{
      "title": "Competency",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "Learners in progress",
      "options": {
        "Ascending": "inProgressCount",
        "Descending": "-inProgressCount"
      }
    }, {
      "title": "LearnerCompletions",
      "options": {
        "Ascending": "completedCount",
        "Descending": "-completedCount"
      }
    }, {
      "title": "Learning Paths",
      "options": {
        "Ascending": "learningPaths",
        "Descending": "-learningPaths"
      }
    }, {
      "title": "Learning Path Criteria",
      "options": {
        "Ascending": "learningPathCriteria",
        "Descending": "-learningPathCriteria"
      }
    }];
    $scope.includedGroups = [];
    $scope.updateSelectedGroups = function updateSelectedGroups(newEntity, selectionList) {
      $scope.includedGroups = selectionList;
      $scope.refreshFilter();
    };
    $scope.refreshFilter = function refreshFilter() {
      delete $scope.items; // clear the cache to force a server-side call with new group info
      $scope.fetch();
    };
  }]);
})();
